module.exports = __webpack_public_path__ + "static/media/add_element.36b10aba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/add_element.jpg
// module id = 1844
// module chunks = 0